var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

define(["require", "exports", "react"], function (require, exports, react_1) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  react_1 = __importDefault(react_1);

  var SoundCloudEmbedded = function SoundCloudEmbedded(_a) {
    var url = _a.url,
        _b = _a.width,
        width = _b === void 0 ? '100%' : _b,
        _c = _a.height,
        height = _c === void 0 ? '450px' : _c,
        _d = _a.autoPlay,
        autoPlay = _d === void 0 ? false : _d,
        _e = _a.hideRelated,
        hideRelated = _e === void 0 ? false : _e,
        _f = _a.showComments,
        showComments = _f === void 0 ? false : _f,
        _g = _a.showUser,
        showUser = _g === void 0 ? true : _g,
        _h = _a.showReposts,
        showReposts = _h === void 0 ? false : _h,
        _j = _a.visual,
        visual = _j === void 0 ? true : _j,
        _k = _a.color,
        color = _k === void 0 ? 'ff5500' : _k;
    var src = visual ? "https://w.soundcloud.com/player/?url=" + url + "&amp;auto_play=" + autoPlay + "&amp;hide_related=" + hideRelated + "&amp;show_comments=" + showComments + "&amp;show_user=" + showUser + "&amp;show_reposts=" + showReposts + "&amp;visual=" + visual : "https://w.soundcloud.com/player/?url=" + url + "&amp;color=" + color + "&amp;auto_play=" + autoPlay + "&amp;hide_related=" + hideRelated + "&amp;show_comments=" + showComments + "&amp;show_user=" + showUser + "&amp;show_reposts=" + showReposts;
    return react_1.default.createElement("iframe", {
      width: width,
      height: visual ? height : 'auto',
      scrolling: "no",
      src: src
    });
  };

  exports.default = SoundCloudEmbedded;
});